"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTouchOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.57 15.18a21.11 21.11 0 00-9.76-3.13l-1.5-7.48A3.2 3.2 0 0011 5.2V18l-1.43-1a3.84 3.84 0 00-2.71-1 5 5 0 00-3.73 2.46l-.38.6L11.5 30h7.58c5.82 0 9-2.38 9.34-7.08l.58-7.41zm-2.14 7.58c-.29 3.62-2.56 5.24-7.35 5.24h-6.62l-7.22-9A2.71 2.71 0 017 18c.31 0 .58 0 1.41.63L13 21.94V5.2a1.2 1.2 0 012.35-.2l1.8 9h.78a20.13 20.13 0 019 2.53z" })));
}
exports.default = SvgTouchOutline;
//# sourceMappingURL=TouchOutline.js.map